import { APP_ROUTES, useAppSelector, useAppTranslation } from "@/utils";
import { PhRCaretLeft, PhRGitMerge, PhRHeadset, PhRPower, PhRQuestion, PhRUser, PhRx } from "@payping/icons";
import { Divider, Drawer, Flex, Menu, Typography } from "@payping/web-components";
import { ComponentProps, useState } from "react";
import { useNavigate } from "react-router";
import { HOME_INSTALLMENT_FILTER } from "../Overview/keys";

const HomeProfilePage = () => {
  const { t } = useAppTranslation();
  const profile = useAppSelector((state) => state.bnplConsumer.profile);
  const [open, setOpen] = useState(true);

  const navigate = useNavigate();

  const handleCloseDrawer = () => {
    setOpen(false);
    navigate(`${APP_ROUTES.home.overview.url}?status=${HOME_INSTALLMENT_FILTER.DELAYED}`);
  };

  type MenuItem = Required<ComponentProps<typeof Menu>>["items"][number];

  const items: MenuItem[] = [
    {
      key: "account",
      icon: <PhRUser width={16} />,
      label: t("common.account"),
      itemIcon: <PhRCaretLeft width={16} height={16} />,
      onClick() {
        navigate(APP_ROUTES.home.profile.account.url);
      },
    },
    {
      key: "help",
      icon: <PhRQuestion width={16} />,
      label: t("common.help"),
      itemIcon: <PhRCaretLeft width={16} height={16} />,
      disabled: true,
    },
    {
      key: "support",
      icon: <PhRHeadset width={16} />,
      label: t("common.support"),
      itemIcon: <PhRCaretLeft width={16} height={16} />,
      disabled: true,
    },
    {
      key: "version",
      icon: <PhRGitMerge width={16} />,
      label: (
        <Flex gap={"small"}>
          <span>{t("common.version")}</span>
          <span className="tw:text-color-text-tertiary">0.0.39</span>
        </Flex>
      ),
      itemIcon: <PhRCaretLeft width={16} height={16} />,
      disabled: true,
    },
  ];

  return (
    <Drawer
      open={open}
      title={
        <Flex align="center" gap={"small"}>
          <Typography.Text>{t("common.profile")}</Typography.Text>
        </Flex>
      }
      onClose={handleCloseDrawer}
      size={"100%"}
      placement={"left"}
      closeIcon={false}
      mask={false}
      classNames={{ header: "tw:py-3! tw:px-4! tw:items-center", body: "tw:px-0!", content: "tw:rounded-md!" }}
      extra={
        <PhRx
          width={16}
          height={16}
          className="tw:mt-1! tw:cursor-pointer tw:p-0!"
          onClick={() => {
            handleCloseDrawer();
          }}
        />
      }
      getContainer={false}
    >
      <Flex className="tw:w-full" justify="center" gap={"large"} vertical align="center">
        <Flex
          align="center"
          justify="center"
          className="tw:mt-6! tw:h-18.75 tw:w-18 tw:rounded-full tw:bg-color-primary-bg"
        >
          <PhRUser width={45} height={45} className="tw:text-color-primary" />
        </Flex>
        <Flex vertical gap={"small"} className="tw:w-full" justify="center" align="center">
          <Typography.Title level={5} className="tw:m-0!">
            {profile.fullName ?? ""}
          </Typography.Title>
          <Typography.Text>{profile.mobileNumber ?? ""}</Typography.Text>
        </Flex>
      </Flex>
      <Flex className="tw:mt-8! tw:w-full" vertical>
        <Flex className="tw:w-full" vertical>
          <Divider className="tw:m-0! tw:w-full" />
          <Menu className="tw:w-full tw:border-none! tw:py-4!" mode="inline" items={items} />
          <Divider className="tw:m-0! tw:w-full" />
        </Flex>
        <Menu
          className="tw:w-full tw:border-none! tw:py-4!"
          mode="vertical"
          items={[
            {
              key: "exit",
              icon: <PhRPower width={16} />,
              label: t("common.exit"),
              onClick() {
                navigate(APP_ROUTES.logout.url);
              },
            },
          ]}
        />
      </Flex>
    </Drawer>
  );
};

export default HomeProfilePage;
